import apiClient from './client';
import { endpoints } from './endpoints';
import type { HeaderMenu } from '@/types';

export const headerMenuService = {
  async list(): Promise<{ data: HeaderMenu[] } | unknown> {
    try {
      const response = await apiClient.get(endpoints.headerMenus.list);
      return response.data;
    } catch {
      console.warn('Endpoint de menus do header não encontrado, usando menus padrão');
      return { data: [] };
    }
  },
  async getById(id: string): Promise<unknown> {
    const response = await apiClient.get(endpoints.headerMenus.get(id));
    return response.data;
  },
  async create(menuData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.post(endpoints.headerMenus.create, menuData);
    return response.data;
  },
  async update(id: string, menuData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.put(endpoints.headerMenus.update(id), menuData);
    return response.data;
  },
  async delete(id: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.headerMenus.delete(id));
    return response.data;
  },
  async reorder(menuIds: string[]): Promise<unknown> {
    const response = await apiClient.post(endpoints.headerMenus.reorder, { menuIds });
    return response.data;
  },
};
